import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4421a089"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["frisbuy-story-progress-bar", {
      'frisbuy-story-progress-bar__hide_ig': _ctx.isHideIg,
    }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["self","stop"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postCount, (step, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["frisbuy-story-progress-bar__step", {
        'frisbuy-in-progress': index === _ctx.currentPostIndex,
        'frisbuy-is-viewed': _ctx.currentPostIndex > index,
      }]),
        key: step + index,
        onClick: ($event: any) => (_ctx.$emit('selectStep', index))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["frisbuy-step-progress", {
          '--transition': _ctx.isInProgress,
        }]),
          style: _normalizeStyle(
          index == _ctx.currentPostIndex && {
            marginLeft: `-${100 - _ctx.currentSlideProgress}%`,
          }
        )
        }, null, 6)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}